import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import _ from 'lodash';
import {User} from '../models/user';
import {Tournament} from '../models/tournament';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  // [GET] users
  public getUsers(): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.auths, {
      params: {},
    });
  }

  // [POST] create user
  public createUser(user: User): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.auths, user, {
      params: {}, observe: 'response'
    });
  }

  // [PATCH] update user
  public updateUser(user: User): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
    (environment.api_server + `${environment.api_endpoints.auths}/${user.id}`,
      user, { params: {}, observe: 'response' });
  }

  // [POST] change Password
  public changePassword(newPassword: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
    (environment.api_server + `${environment.api_endpoints.passwordChange}`,
      { password: newPassword}, { params: {}, observe: 'response' });
  }

  // [POST] change Password
  public changePasswordOtherUser(userId: string, newPassword: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
    (environment.api_server + _.replace(environment.api_endpoints.passwordChangeOtherUser, ':id', userId),
      { password: newPassword}, { params: {}, observe: 'response' });
  }


  // [DELETE] update user
  public disableUser(user: User): Observable<{ [index: string]: any; }> {
    return this.httpClient.delete<HttpResponse<object>>
    (environment.api_server + `${environment.api_endpoints.auths}/${user.id}`,
      { params: {}, observe: 'response' });
  }


}
